module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "height": "1600px"
    },
    attrs: {
      "id": "djs-body-click"
    }
  }, [_c('div', {
    staticClass: "header"
  }), _vm._v(" "), _c('SideNav'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1rem 1rem 1rem 75px"
    },
    attrs: {
      "id": "djs-content-container"
    }
  }, [_c('AssignHours')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7452aed4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Show.vue
// module id = 2011
// module chunks = 1